
























import type { PropType } from '@vue/composition-api';
import { defineComponent } from '@vue/composition-api';
import { ButtonType } from '@getaccept/lib-ui';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import type { DocumentQesFile } from '../types/document-qes-file';

export default defineComponent({
  props: {
    files: { type: Array as PropType<DocumentQesFile[]>, required: true },
    isEditable: { type: Boolean },
  },
  emits: ['delete', 'download'],
  setup() {
    const fileName = (file: DocumentQesFile) =>
      `${file.name || file.id}.${file.fileType.toLowerCase()}`;

    return { fileName, t, ButtonType };
  },
});
